define(function (require) {
    'use strict';

    /* Dépendances */

    $ = require("jquery");
    _ = require("lodash");
    var moment = require("moment");
    var QuantaNumber = require("QuantaNumber");
    var QuantaFormNumber = require("QuantaFormNumber");
    var i18n = require("i18n");
    var locales = require("quanta-form-validator-locales");

    /* ----------- */

    var defaults_ = {
        feedBackUi: { //Classe à appliquer sur la div englobant l'input (en général "form-group")
            classHasSuccess: "has-success",
            classHasError: "has-error",
        },
        feedBackDisplay: {
            isDisplayUiSuccess: false, //Est-ce qu'on applique la class "classHasSuccess" lors de la validation de l'input
            isDisplayIconSuccess: false, //Est-ce qu'on affiche l'icone lors de la validation de l'input
            isDisplayUiError: true, //Est-ce qu'on applique la class "classHasError" lors de l'erreur de validation de l'input
            isDisplayIconError: false, //Est-ce qu'on affiche l'icone lors de l'erreur de validation de l'input
            isDisplayMessageError: true //Est-ce qu'on affiche le message lors de l'erreur de validation de l'input
        },
        onStatutChange: function (cStatut) { }, //Retourne le statut de la validation
		locale: i18n.locale(),
		//permet de specifier un container custom, (à souvent coupler avec un customRemoveOlderValidation pour le nettoyage)
		customGetErrorContainer: function ($selectedInput, settings) { return null; },
		//si customRemoveOlderValidation return truthy, c'est considéré comme géré par le custom, sinon, on continue avec le remove par defaut
		customRemoveOlderValidation: function ($selectedInput, settings) { return false;  }, 
		CustomWriteFunc: function(selectedInput, message, settings){
			//On ajoute l'icone d'erreur en fonction du type d'input (cas particuliers sur les "select" les "datepicker" pour ne pas supperposer l'icone sur un symbole existant
        //SetUserInterface(selectedInput, false, displayIcon);

			if (getSettingsCurrentMode(selectedInput) == modeValidation.VALIDATION_UI && settings.feedBackDisplay.isDisplayMessageError && selectedInput.attr('data-no-message') !== 'true') {
            var html = "<small class=\"help-block\" data-validation-result=\"invalid\">" + message + "</small>";

			var errorContainer = settings.customGetErrorContainer(selectedInput, settings);
			errorContainer = errorContainer || selectedInput.attr("data-message-container");

			if (!errorContainer)
			{
                //Si on a pas spécifié de container spécifique pour afficher l'erreur, on l'affiche après le champs en cours de validation
                errorContainer = selectedInput;

                //Affichage spécifique si on est dans un "input-group"
                if (isInInputGroup(selectedInput)) {
                    //On est dans un input group, on affiche le message après la div pour ne pas déformer les éléments bootstrap
                    selectedInput.closest(".input-group").after(html);
                } else {
                    errorContainer.after(html);
                }
            }
            else {

                if (errorContainer === "SELF") {
                    selectedInput.addClass('input-error');
                    selectedInput.attr("title", message);

                    //Timeout pour être sûr que le tooltip('hide') de RemoveOlderValidation est bien terminé
                    setTimeout(function () {
                        selectedInput.tooltip({ trigger: "manual", template: "<div class='tooltip'><div class='tooltip-arrow'></div><div class='tooltip-inner'></div></div>'" }).tooltip("show");
                    }, 200);
                    //selectedInput.on("focusout", function () { $(this).tooltip("show") })
                } else {
                    errorContainer = $(errorContainer);
                    if (errorContainer.hasClass("hidden")) {
                        errorContainer.removeClass("hidden");
                    }
                    errorContainer.html(html);
                    if (settings.feedBackDisplay.isDisplayUiError == true) {
                        errorContainer.addClass(settings.feedBackUi.classHasError);
                    }
                }

            }
        }
		}
    };

    var methods = {
        init: init,
        getSettings: getSettings,
        setSettings: setSettings,
        IsValid: IsValid,
        IsValidUpdateUI: ValidateUi,
        RemoveUi: RemoveUi,
        DisableValidation: DisableValidation,
        EnableValidation: EnableValidation,
        SetUi: SetUserInterface,
        setLocale: setLocale
    };

	function initLocale(settings)
	{
       setLocale(settings.locale)
    }

	function setLocale(locale)
	{
        i18n.QuantaFormValidator = locales[locale] || locales['fr'];
    }


    //#region "Classes interne"
    var g = {

    }

    var modeValidation = {
        VALIDATION_CLASSIQUE: 0,
        VALIDATION_UI: 1
    }

    var StatusValidation = {
        ERROR: { value: "error", returnCode: false },
        SUCCESS: { value: "success", returnCode: true },
        VALIDATING: { value: "validating", returnCode: true },
    }

    var fieldToSkip = Array();
    //#endregion

    setLocale(defaults_.locale);

    $.fn.QuantaFormValidator = function (methodOrOptions) {
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist on QuantaFormValidator');
        }
    };

    /* 
     * Initialise le validateur de formulaire avec l'UI d'activé par défaut
     */
    function init(options) {
        var settings = $.extend(true, {}, defaults_, options);

        var self = $(this);
        self.QuantaFormValidator("setSettings", settings);

        initLocale(settings);

        self.on('change', function (event) { //blur
            var fieldResult = $.proxy(ValidateUi, this)();
        });

        return self;
    }

    //#region "Module settings"
    function setSettings(options) {
        if (options != null)
            $(this).data("settings", options);
    }

    function getSettings() {
        if ($(this).data("settings") != null){
			var options = $(this).data("settings");
            return $.extend(true, {}, defaults_, options);;
		}

        return defaults_;
    }

    function disableIconSettings($this) {
        var noIconsSettings = $this.QuantaFormValidator("getSettings");
        noIconsSettings.feedBackDisplay.isDisplayIconError = false;
        noIconsSettings.feedBackDisplay.isDisplayIconSuccess = false;
        $this.QuantaFormValidator("setSettings", noIconsSettings);
    }

    function setSettingsCurrentMode($this, mode) {
        $this.data("settingsMode", mode);
    }

    function getSettingsCurrentMode($this) {
        return $this.data("settingsMode");
    }

    function removeSettingsCurrentMode($this) {
        $this.data("settingsMode", null);
    }
    //#endregion

    /* Fonction qui renvoit une liste d'input cohérent à valider
     * i.e. : Sur une liste d'input passé en paramètre, ne renvoit que les champs <> undefined et ceux qui doivent être validé (data-validation = true)
     */
    function filterInput($input) {
        var validField = {};
        var $this = $(this);
        if ($input !== undefined && $input.length !== undefined) {
            validField["valid"] = $input.filter(function () {
                if (_validateAttribute($(this), "data-validation", true)) {
                    return $(this);
                }
            });
        }
        return validField["valid"];
    }

    /*
     * Retourne un booleen pour indiquer si l'ensemble des champs passés en paramètres est valide
     */
    function IsValid() {
        setSettingsCurrentMode($(this), modeValidation.VALIDATION_CLASSIQUE);
        $(this).data("settingsMode", modeValidation.VALIDATION_CLASSIQUE);
        return checkDataValidation($(this), function ($this) {
            return CheckInput($this, false);
        })
    }

    /*
     * Valide le formulaire en ajoutant l'UI sur les champs à valider
     */
    function ValidateUi() {
        setSettingsCurrentMode($(this), modeValidation.VALIDATION_UI);
        return checkDataValidation($(this), function ($this) {
            //On enlève toutes les anciennes validations qu'il pouvait y avoir
            RemoveOlderValidation($this);

            var isValid = CheckInput($this);
            SetUserInterface($this, isValid);
            return isValid;
        })
    }

    function checkDataValidation($this, checkInputCallBack) {
        var isValidated = true;
        var $input = filterInput($this);

        if ($input !== undefined && $input.length !== undefined) {
            $input.each(function () {
                if (checkInputCallBack($(this)) === false) {
                    isValidated = false;
                }
            });
            fieldToSkip = [];
        }

        return isValidated;
    }

    /* Vérifie la validité du formulaire */
    function CheckInput($input) {
        //On ne valide que les champs avec un data-validation != "false"
        if (_validateAttribute($input, "data-validation", true)) {
            //On parcourt la liste de toutes les validations à valider
            var StatusResult = GetAllValidationParameters($input);

            //Travail préliminaire (pour les champs avec validation chainé)
            //initAfterValidation($input, StatusResult.returnCode);

            return StatusResult.returnCode;
        }
        return false;
    }

    //function initAfterValidation($input, status) {
    //    $("[data-chain-selector]").each(function () {
    //        var $this = $(this);
    //        var selector = $this.attr("data-chain-selector");

    //        //On vérifie si l'un des champs pointe vers l'input actuel
    //        $input.each(function() {
    //            if ($(selector)[0] === $(this)[0]) {
    //                var isCurrentlyValidated = _validateAttribute($(this), "data-validation", true);
    //                var needToBeValidated = $(this).attr("data-chain-valid") !== "false" && StatusValidation.SUCCESS;
    //                if(!(isCurrentlyValidated && needToBeValidated.returnCode)) {
    //                    RemoveOlderValidation($(selector));
    //                    $(this).attr("data-validation", needToBeValidated.returnCode);
    //                }
                    
    //            }
    //        });
    //    });
    //}

    /*
     * Enlève l'UI de tout les champs passés en paramètre
     */
    function RemoveUi() {
        //var $input = filterInput($(this));
        var $input = $(this);

        if ($input.length > 0) {
            $input.each(function () {
                //On enlève toutes les anciennes validations qu'il pouvait y avoir
                RemoveOlderValidation($(this));
            });
        }
    }


    /*
     * Désactive la validation de tout les champs passés en paramètre
     */
    function DisableValidation() {
        //console.log("debug");
        var $input = filterInput($(this));

        if ($input !== undefined) {
            $input.each(function () {
                //On enlève toutes les anciennes validations qu'il pouvait y avoir
                RemoveOlderValidation($(this));

                $(this).attr("data-validation", false);
            });
        }
    }

    /*
     * Active la validation de tout les champs passés en paramètre
     */
    function EnableValidation() {
        var $input = $(this);

        if ($input !== undefined) {
            $input.each(function () {
                $(this).attr("data-validation", true);
            });
        }
    }

    function CheckAddField(field, attribut, list) {
        if (list.val() == "")
            (field.attr(attribut, "true"))
        else
        (field.attr(attribut, "false"))
    }

    function GetAllValidationParameters(selectedInput) {
        /* A vérifier en premier */
        if (!_.includes(fieldToSkip, selectedInput[0])) {
            var statusResponse = checkAtLeastOne(selectedInput);
            if (statusResponse !== StatusValidation.VALIDATING) {
                return statusResponse;
            }
            return CheckValidation(selectedInput);
        }
        return StatusValidation.SUCCESS; //On renvoit vrai car si le champs en cours doit être ignoré, c'est qu'il a déja été validé
    }

    function CheckValidation(selectedInput) {

        var checkRequiredStatus = checkRequired(selectedInput);
        if (checkRequiredStatus !== StatusValidation.VALIDATING) {
            return checkRequiredStatus;
        }

        if (checkLength(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkEmail(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkUrl(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkText(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkPhone(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkPattern(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkNumeric(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkNumericMinValue(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkNumericMaxValue(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkIsin(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
		}

		if (checkIBAN(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

		if (checkBIC(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkEqual(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkAutocomplete(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        if (checkDate(selectedInput) === StatusValidation.ERROR) {
            return StatusValidation.ERROR;
        }

        return StatusValidation.SUCCESS;
    }

    function RemoveOlderValidation(selectedInput) {
        var $selectedInput = $(selectedInput);
        var settings = $selectedInput.QuantaFormValidator("getSettings");

		var bHasBeenHandledByCustom = settings.customRemoveOlderValidation($selectedInput, settings);
		if (bHasBeenHandledByCustom) { return; }

        if ($selectedInput !== undefined && $selectedInput.length !== undefined) {
            $selectedInput.each(function () {
                var $input = $(this);
                var $inputGroup = $input.closest("[class*='form-group']")

                $inputGroup.removeClass("has-feedback");
                if (settings.feedBackDisplay.isDisplayUiError == true) {
                    $inputGroup.removeClass(settings.feedBackUi.classHasError);
                }

                if (settings.feedBackDisplay.isDisplayUiSuccess == true) {
                    $inputGroup.removeClass(settings.feedBackUi.classHasSuccess);
                }
                $inputGroup.removeClass("autocompleted"); //To see 

                var parentInput = $input.parent();

                //On regarde si le message est écrit sous l'input (par defaut) ou bien dans une div spécifiée
                if ($input.attr("data-message-container") !== undefined) {
                    if ($input.attr("data-message-container") === "SELF") {
                        if ($input.hasClass("input-error")) {
                            $input.removeClass("input-error");
                            $input.tooltip("hide"); //.tooltip({ trigger: "manual" })
                            //$input.on("focusout", function () { $(this).tooltip("destroy") });
                        }
                    } else {
                        var $containerMessage = $($input.attr("data-message-container"));
                        if (settings.feedBackDisplay.isDisplayUiError == true) {
                            $input.removeClass(settings.feedBackUi.classHasError);
                        }

                        //On ajoute la classe "hidden" au container
                        if (!$containerMessage.hasClass("hidden")) {
                            $containerMessage.addClass("hidden");
                        }
                        $containerMessage.find("[data-validation-result]").remove();
                    }
                } else {
                    //Pas de container spécifié
                    if (isInInputGroup($input)) {
                        parentInput.next("small").remove();
                    } else {
                        parentInput.children("small").remove();
                    }
                }

                //On elève l'icone de validation
                parentInput.children("i").remove();

                if ($input.hasClass("input-error")) {
                    $input.removeClass("input-error")
                    $input.tooltip({ trigger: "manual" }).tooltip("hide");
                    $input.on("focusout", function () { $(this).tooltip("destroy") })
                }

                //On récupère la div parent d'où se trouve notre input
                //var parentInput = $selectedInput.parent();
                //parentInput.children("small").remove();
                //parentInput.children("i").remove();
            });
        }

    }

    /*
     * Retourne true si l'input est dans un "input-group" de bootstrap
     */
    function isInInputGroup($this) {
        return $this.closest(".input-group").length > 0;
    }

    function WriteMessageForInvalidInput(selectedInput, message, displayIcon) {
        var settings = selectedInput.QuantaFormValidator("getSettings");

        settings.CustomWriteFunc(selectedInput,message,settings);

        return false;
    }

    function SetUserInterface(selectedInput, isValid) {
        var $selectedInput = $(selectedInput);
        var settings = $selectedInput.QuantaFormValidator("getSettings");

        var offsetIcon = {
            offsetRight: 0,
            offsetTop: 0
        };

        //On enlève l'ancienne validation sur le champs en cours
        //RemoveOlderValidation(selectedInput);
        if ((isValid && settings.feedBackDisplay.isDisplayIconSuccess) || (!isValid && settings.feedBackDisplay.isDisplayIconError)) {
            $selectedInput.closest("[class*='form-group']").addClass("has-feedback");
        }

        //On décale l'icone sur certains champs particuliers
        if (selectedInput[0].tagName.toLowerCase() === "select") {
            offsetIcon.offsetRight = 25;
        }
        //Décale l'icône sur les "input-sm" de Bootstrap
        if (selectedInput.hasClass("input-sm")) {
            offsetIcon.offsetRight = 8;
            offsetIcon.offsetTop = -2;
        }
        if (!isValid) {
            if (settings.feedBackDisplay.isDisplayUiError == true) {
                $selectedInput.closest("[class*='form-group']").addClass(settings.feedBackUi.classHasError);
            }
            if (settings.feedBackDisplay.isDisplayIconError) {
                $selectedInput.after("<i class=\"form-control-feedback glyphicon glyphicon-remove\" " + (offsetIcon.offsetRight > 0 | offsetIcon.offsetTop > 0 ? "style='" + (offsetIcon.offsetRight > 0 ? "right:" + offsetIcon.offsetRight + "px;" : "") + (offsetIcon.offsetRight > 0 ? "top:" + offsetIcon.offsetTop + "px;'" : "") : "") + "></i>");
                //$selectedInput.after("<i class=\"form-control-feedback glyphicon glyphicon-remove\" " + (offsetIcon.offsetRight > 0 | offsetIcon.offsetTop > 0 ? "style='right:" + offsetIcon.offsetRight + "px;'" : "") + " ></i>");
            }
        }
        else {
            if (settings.feedBackDisplay.isDisplayUiSuccess == true) {
                $selectedInput.closest("[class*='form-group']").addClass(settings.feedBackUi.classHasSuccess);
            }
            if (settings.feedBackDisplay.isDisplayIconSuccess) {
                $selectedInput.after("<i class=\"form-control-feedback glyphicon glyphicon-ok\" " + (offsetIcon.offsetRight > 0 | offsetIcon.offsetTop > 0 ? "style='" + (offsetIcon.offsetRight > 0 ? "right:" + offsetIcon.offsetRight + "px;" : "") + (offsetIcon.offsetRight > 0 ? "top:" + offsetIcon.offsetTop + "px;'" : "") : "") + "></i>");
            }
        }
    }

    /* --
     * VERIFICATION DES CHAMPS A VALIDER
      -- */

    //#region Champs required
    /* Vérifie si le champs est vide (code : data-required) */
    function checkRequired(selectedInput) {
        if (_validateAttribute(selectedInput, "data-required")) {
            var isValid = isFieldEmpty(selectedInput);

            if (!isValid) {
                var errorMessage = getErrorMessage(selectedInput, "data-required-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage);
                return StatusValidation.ERROR;
            }
        } else {
            //Le champs est facultatif, si il est vide on arrête la validation
            if (!isFieldEmpty(selectedInput)) {
                return StatusValidation.SUCCESS;
            }
        }
        return StatusValidation.VALIDATING;
    }

    function isFieldEmpty(selectedInput) {
        var isValid = false;
        var isWysiwyg = _validateAttribute(selectedInput, "data-wysiwyg");
        /* On applique différentes règles de validation en fonction du type de l'input */
        var inputType = selectedInput.attr("type");
        if (inputType === undefined) {
            switch (selectedInput[0].nodeName.toLowerCase()) {
                case "textarea":
                    inputType = "text";
                    break;
            }
        }
        switch (inputType) {
            case "text":
                if (isWysiwyg) {
                    isValid = selectedInput.wysiwyg("getContent").trim() !== ""; //checkRequiredCkEditor(selectedInput);
                }
                else {
                    isValid = checkRequiredTextInput(selectedInput);
                }
                break;
            case "checkbox":
                disableIconSettings(selectedInput); //En attendant de mieux gérer les icones
            case "radio":
                disableIconSettings(selectedInput);
                isValid = checkRadioRequired(selectedInput);
                break
            case "":
            default:
                if (selectedInput.val() == null) {
                    isValid = false;
                } else {
                    isValid = (selectedInput.val().trim() != "");
                }
                break;
        }

        return isValid;
    }

    function checkRequiredTextInput(selectedInput) {
        var text;
        text = selectedInput.val();

        return text.trim() !== "";
    }

    function checkRadioRequired(selectedInput) {
        //On regarde si d'autres boutons radio lui sont associé
        var inputName = selectedInput.attr("name");

        if (inputName != null) {
            var $listRadio = $("input[type='radio'][name='" + inputName + "']");

            if ($listRadio.length > 0) {
                //Si parmit la liste des boutons radio, certains ont l'attribut "data-atleast-selector" alors on ne fait rien (la suite des méthodes analysera l'attribut)
                if ($listRadio.attr("data-atleast-selector") == null) {
                    $listRadio.attr("data-atleast-selector", _generateUniqueSelector());

                    //On lui attribut le message custom associé
                    var sMessageError = selectedInput.attr("data-required-message");
                    if (sMessageError != null && sMessageError != "") {
                        selectedInput.removeAttr("data-required-message");
                        selectedInput.attr("data-atleast-message", sMessageError);
                    }
                }
            }
        }

        if (selectedInput.prop('checked')) {
            return true;
        }
        return false;
    }

    function checkRequiredCkEditor(selectedInput) {
        var text;
        text = eval("CKEDITOR.instances." + selectedInput.attr("id") + ".document.getBody().getChild(0).getText()");

        return text.trim();
    }
    //#endregion

    //#region Longueur chaine de caractère
    /* Vérifie le nombre de caractère du champs (code : data-string-length) */
    function checkLength(selectedInput) {
        //On vérifie qu'il n'y ai pas d'erreur dans le min / max
        var bCheckFieldLength = StatusValidation.SUCCESS;
        var isMinLength = _validateAttribute(selectedInput, "data-string-length");
        if (isMinLength) {
            var minLength = selectedInput.attr("data-string-length-min");
            var maxLength = selectedInput.attr("data-string-length-max");
            var eqLength = selectedInput.attr("data-string-length-equal");

            //Erreur si aucun paramètre min / max / equal n'a été renseigné
            if (minLength === undefined && maxLength === undefined && eqLength === undefined) {
                bCheckFieldLength = StatusValidation.ERROR;
                //console.log("Aucun min et / ou max renseigné pour le champs : " + selectedInput.attr("id"));
            }

            //Erreur si min > max
            if (minLength !== undefined && maxLength != undefined && $.isNumeric(minLength) && $.isNumeric(maxLength)) {
                minLength = parseInt(minLength);
                maxLength = parseInt(maxLength);
                if (minLength > maxLength) {
                    bCheckFieldLength = StatusValidation.ERROR;
                    //console.log("Le min " + minLength + " est supérieur au max " + maxLength + " pour le champs : " + selectedInput.attr("id"));
                }
            }

            //Erreur si une longueur exact est demandé mais qu'on a aussi demandé un min / max
            if (eqLength !== undefined && (minLength !== undefined || maxLength !== undefined)) {
                bCheckFieldLength = StatusValidation.ERROR;
                //console.log("Une longueur égale et min ou max est demandé pour le champs : " + selectedInput.attr("id"));
            }

            if (bCheckFieldLength) {
                if (checkMinLength(selectedInput) === StatusValidation.ERROR) {
                    return StatusValidation.ERROR;
                }
                if (checkEqualLength(selectedInput) === StatusValidation.ERROR) {
                    return StatusValidation.ERROR;
                }
                if (checkMaxLength(selectedInput) === StatusValidation.ERROR) {
                    return StatusValidation.ERROR;
                }
            }
        }
    }

    /* Vérifie le nombre de caractère minimum du champs (code : data-string-length-min).
     * Attention : doit être précédé de l'attribut : data-string-length="true"
     */
    function checkMinLength(selectedInput) {
        if (selectedInput.val().length > 0) {
            var minLength = selectedInput.attr("data-string-length-min");

            if (minLength !== undefined) {
                if (!(selectedInput.val().length >= minLength)) {
                    var errorMessage = getErrorMessage(selectedInput, "data-string-length-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage);
                    return StatusValidation.ERROR;
                }
            }
        }
    }

    /* Vérifie le nombre de caractère maximum du champs (code : data-string-length-max) 
     * Attention : doit être précédé de l'attribut : data-string-length="true"
     */
    function checkMaxLength(selectedInput) {
        if (selectedInput.val().length > 0) {
            var maxLength = selectedInput.attr("data-string-length-max");

            if (maxLength !== undefined) {
                if (!(selectedInput.val().length <= maxLength)) {
                    var errorMessage = getErrorMessage(selectedInput, "data-string-length-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage);
                    return StatusValidation.ERROR;
                }
            }
        }
    }

    /* Vérifie que le nombre de caractère du champs est bien égal 
     * Attention : doit être précédé de l'attribut : data-string-length="true"
     */
    function checkEqualLength(selectedInput) {
        if (selectedInput.val().length > 0) {
            var eqLength = selectedInput.attr("data-string-length-equal");

            if (eqLength !== undefined) {
                eqLength = parseInt(eqLength);
                if (!(selectedInput.val().length === eqLength)) {
                    var errorMessage = getErrorMessage(selectedInput, "data-string-length-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage);
                    return StatusValidation.ERROR;
                }
            }
        }
    }
    //#endregion

    //#region ISIN
    /* Vérifie que le champs correspond au pattern du code isin (code : data-ISIN) */
    function checkIsin(selectedInput) {
        if (_validateAttribute(selectedInput, "data-ISIN")) {
            var code = selectedInput.val();
            var location = code.substring(0, 2);
            var num = code.substring(2, 12);
            if (!/^[A-Z]+$/.test(location) || !$.isNumeric(num)) {
                var errorMessage = getErrorMessage(selectedInput, "data-isin-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage);
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

	//#region ISIN
	/* Vérifie que le champs correspond au pattern du code isin (code : data-ISIN) */
	function checkIBAN(selectedInput) {
		if (_validateAttribute(selectedInput, "data-IBAN")) {
			var input = selectedInput.val();
			
			if (!isValidIBANNumber(input)) {
				var errorMessage = getErrorMessage(selectedInput, "data-iban-message");
				WriteMessageForInvalidInput(selectedInput, errorMessage);
				return StatusValidation.ERROR;
			}
		}

		function isValidIBANNumber(input) {
			var CODE_LENGTHS = {
				AD: 24, AE: 23, AT: 20, AZ: 28, BA: 20, BE: 16, BG: 22, BH: 22, BR: 29,
				CH: 21, CR: 21, CY: 28, CZ: 24, DE: 22, DK: 18, DO: 28, EE: 20, ES: 24,
				FI: 18, FO: 18, FR: 27, GB: 22, GI: 23, GL: 18, GR: 27, GT: 28, HR: 21,
				HU: 28, IE: 22, IL: 23, IS: 26, IT: 27, JO: 30, KW: 30, KZ: 20, LB: 28,
				LI: 21, LT: 20, LU: 20, LV: 21, MC: 27, MD: 24, ME: 22, MK: 19, MR: 27,
				MT: 31, MU: 30, NL: 18, NO: 15, PK: 24, PL: 28, PS: 29, PT: 25, QA: 29,
				RO: 24, RS: 22, SA: 24, SE: 24, SI: 19, SK: 24, SM: 27, TN: 24, TR: 26,
				AL: 28, BY: 28, EG: 29, GE: 22, IQ: 23, LC: 32, SC: 31, ST: 25, SV: 28,
				TL: 23, UA: 29, VA: 22, VG: 24, XK: 20
			};
			var iban = String(input).toUpperCase().replace(/[^A-Z0-9]/g, ''), // keep only alphanumeric characters
				code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/), // match and capture (1) the country code, (2) the check digits, and (3) the rest
				digits;
			// check syntax and length
			if (!code || iban.length !== CODE_LENGTHS[code[1]]) {
				return false;
			}
			// rearrange country code and check digits, and convert chars to ints
			digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, function (letter) {
				return letter.charCodeAt(0) - 55;
			});
			// final check
			return mod97(digits);
		}

		function mod97(string) {
			var checksum = string.slice(0, 2), fragment;
			for (var offset = 2; offset < string.length; offset += 7) {
				fragment = String(checksum) + string.substring(offset, offset + 7);
				checksum = parseInt(fragment, 10) % 97;
			}
			return checksum;
		}

	}
	//#endregion

	//#region BIC
	/* Vérifie que le champs correspond au pattern du code isin (code : data-ISIN) */
	function checkBIC(selectedInput) {
		if (_validateAttribute(selectedInput, "data-BIC")) {
			if (!/[A-Z]{6,6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3,3}){0,1}$/.test(selectedInput.val())) {
				var errorMessage = getErrorMessage(selectedInput, "data-bic-message");
				WriteMessageForInvalidInput(selectedInput, errorMessage);
				return StatusValidation.ERROR;
			}
		}
	}
    //#endregion

    //#region Email
    /* Vérifie que le champs correspond au pattern d'une adresse mail (code : data-email) */
    function checkEmail(selectedInput) {
        if (_validateAttribute(selectedInput, "data-email")) {
            var emailInput = selectedInput.val();
            var emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            var emailPattern = /^(.+)@(.+)\.(.+)$/;
            var isValid = emailPattern.test(emailInput);

            if (isValid === false) {
                var errorMessage = getErrorMessage(selectedInput, "data-email-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage);
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

    //#region URL
    /* Vérifie que le champs correspond au pattern d'une URL (code : data-url) */
    function checkUrl(selectedInput) {
        if (_validateAttribute(selectedInput, "data-url")) {
            var urlInput = selectedInput.val();
            var urlPattern = /^(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9\-]*[A-Za-z0-9])$/
            var isValid = urlPattern.test(urlInput);

            if (isValid === false) {
                var errorMessage = getErrorMessage(selectedInput, "data-url-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage);
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

    //#region Gestion des nombres
    /* 
     * Vérifie que le champs est un numérique (décimal ou entier) (code : data-number) 
     * Si le champs doit être obligatoirement un entier rajouter le code : data-number-integer
     */
    function checkNumeric(selectedInput) {
        if (_validateAttribute(selectedInput, "data-number")) {
            var sValue = selectedInput.val();
            var isValid = false;

            if ($.fn.QuantaFormNumber.IsInstanciated(selectedInput)) {
                sValue = $.fn.QuantaFormNumber.ClearValue(selectedInput);
            }

			var errorMessage = "";

            //Décimal ou Entier ?
            var isEntier = selectedInput.attr("data-number-integer");
            if (isEntier != undefined & isEntier == "true") {
                //Entier
				isValid = QuantaNumber.IsInteger(sValue);
				errorMessage = getErrorMessage(selectedInput, "data-number-integer-message");
            } else {
                //Décimal
				isValid = QuantaNumber.IsNumeric(sValue);
				errorMessage = getErrorMessage(selectedInput, "data-number-message");
            }

            if (!isValid) {
                WriteMessageForInvalidInput(selectedInput, errorMessage)
                return StatusValidation.ERROR;
            }
        }
    }

    /* 
     * Vérifie que le champs a une valeur numeric maximal (code : data-number-max)
     * Par défaut [0; MAX] (data-number-max-include="true") si besoin d'exclure la borne [0; MAX[ utiliser : data-number-max-include="false"
    */
    function checkNumericMaxValue(selectedInput) {
        var maxValue = selectedInput.attr("data-number-max");
        var inputValue = QuantaNumber.ToFloat(selectedInput.val());

        if (maxValue != undefined) {
            //Borne incluse ?
            var isFalse;
            var isBorneIncluse = selectedInput.attr("data-number-max-include");
            if (isBorneIncluse != undefined & isBorneIncluse == "false") {
                isFalse = QuantaNumber.IsGreater(inputValue, QuantaNumber.ToFloat(maxValue), false);
            } else {
				isFalse = QuantaNumber.IsGreater(inputValue, QuantaNumber.ToFloat(maxValue), true);
            }
            if (isFalse) {
                var errorMessage = getErrorMessage(selectedInput, "data-number-max-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage)
                return StatusValidation.ERROR;
            }
        }
    }

    /* 
     * Vérifie que le champs a une valeur numeric minimal (code : data-number-min)
     * Par défaut [MIN; inf[ (data-number-min-include="true") si besoin d'exclure la borne ]MIN; inf[ utiliser : data-number-min-include="false"
    */
    function checkNumericMinValue(selectedInput) {
        var minValue = selectedInput.attr("data-number-min");
        var inputValue = QuantaNumber.ToFloat(selectedInput.val());

        if (minValue != undefined) {
            //Borne incluse ?
            var isFalse;
            var isBorneIncluse = selectedInput.attr("data-number-min-include");
            if (isBorneIncluse != undefined & isBorneIncluse == "false") {
                isFalse = QuantaNumber.IsLower(inputValue, QuantaNumber.ToFloat(minValue), false);
            } else {
                isFalse = QuantaNumber.IsLower(inputValue, QuantaNumber.ToFloat(minValue), true);
            }
            if (isFalse) {
                var errorMessage = getErrorMessage(selectedInput, "data-number-min-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage)
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

    //#region Texte
    /* Vérifie que le champs ne contient pas de chiffres (code : data-text) */
    function checkText(selectedInput) {
        if (_validateAttribute(selectedInput, "data-text")) {
            var champ = selectedInput.val();
            if (champ.match(/[0-9]+$/)) {
                var errorMessage = getErrorMessage(selectedInput, "data-text-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage)
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

    /* Vérifie que le champs (qui est un autocomplete de jQuery) a bien un élément sélectionné (code : data-autocomplete) */
    function checkAutocomplete(selectedInput) {
        if (_validateAttribute(selectedInput, "data-autocomplete")) {
            if (selectedInput.val().length > 0) {
                if (selectedInput.closest("[class*='form-group']").attr("autocompleted") == "false") {
                    var errorMessage = getErrorMessage(selectedInput, "data-autocomplete-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage)
                    return StatusValidation.ERROR;
                }
            }
        }
    }

    //#region Téléphone
    /* Vérifie que le champs est un numéro de téléphone (code : data-phone) */
    function checkPhone(selectedInput) {
        if (_validateAttribute(selectedInput, "data-phone")) {
            var champ = selectedInput.val();
            //Indicateur (+XXX ou +1-XXX ou 00XXX ou 0) + max 12 groupes de 1 à 2 chiffres
            var phonePattern = /(?:(?:(?:\+|00)(?:[1][-]){0,1}\d{2,3})|0)\s*(?:[\s.-]*\d{1,2}){6,12}$/
            if (!(phonePattern.test(champ))) {
                var errorMessage = getErrorMessage(selectedInput, "data-phone-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage)
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

    //#region Pattern custom
    /* Vérifie que le champs valide le pattern passé en paramètre (code : data-pattern) */
    function checkPattern(selectedInput) {
        var pattern = selectedInput.attr("data-pattern");
        if (pattern != undefined) {
            var champ = selectedInput.val();
            var regex = new RegExp(pattern);
            if (!(regex.test(champ))) {
                var errorMessage = getErrorMessage(selectedInput, "data-pattern-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage)
                return StatusValidation.ERROR;
            }
        }
    }
    //#endregion

    //#region Check date
    /* Vérifie que le champs a bien un format de date valide (code : data-date) */
    function checkDate(selectedInput) {
        if (_validateAttribute(selectedInput, "data-date")) {
            if (checkDatePattern(selectedInput) === StatusValidation.ERROR) {
                return StatusValidation.ERROR;
            }
            if (checkMinDateRange(selectedInput) === StatusValidation.ERROR) {
                return StatusValidation.ERROR;
            }
            if (checkMaxDateRange(selectedInput) === StatusValidation.ERROR) {
                return StatusValidation.ERROR;
            }
        }
    }

    /* 
     * Fonction interne qui retourne le pattern par défaut d'une date si aucune n'a été spécifié en paramètre
     * Par défaut : pattern Français
    */
    function _getDefaultDatePattern() {
        return "DD/MM/YYYY"
    }

    /*
     * Fonction interne qui récupère le pattern de la date à valider
     */
    function _getDatePattern(selectedInput) {
        var datePattern = selectedInput.attr("data-date-pattern");
        if (datePattern != undefined && datePattern) {
            return datePattern;
        }
        return _getDefaultDatePattern(selectedInput);
    }

    /* Vérifie que la date a bien le pattern adéquat. Si aucun pattern passé en paramètre par défaut pattern Francais (code : data-date-pattern) */
    function checkDatePattern(selectedInput) {
        var datePattern = selectedInput.attr("data-date-pattern");
        if (selectedInput.val().length > 0) {
            datePattern = _getDatePattern(selectedInput);

            var momentDate = moment(selectedInput.val(), datePattern);
            if (!moment.isMoment(momentDate) || !momentDate.isValid()) {
                var errorMessage = getErrorMessage(selectedInput, "data-date-pattern-message");
                WriteMessageForInvalidInput(selectedInput, errorMessage);

                return StatusValidation.ERROR;
            }
        } else {
            return StatusValidation.ERROR
        }
    }

    /* 
     * Vérifie que la date est bien supérieur à la date passée en paramètre (code : data-date-min) 
     * Attention la date passée en paramètre doit avoir le même pattern que la date à comparer
     */
    function checkMinDateRange(selectedInput) {
        var dateMinRange = selectedInput.attr("data-date-min");
        if (dateMinRange != undefined) {
            var datePattern = _getDatePattern(selectedInput);
            var momentDateMin = moment(dateMinRange, datePattern);
            if (moment.isMoment(momentDateMin)) {
                var momentDateReference = moment(selectedInput.val(), datePattern);
                if (momentDateReference.isBefore(momentDateMin)) {
                    var errorMessage = getErrorMessage(selectedInput, "data-date-min-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage);

                    return StatusValidation.ERROR;
                }
            } else {
                return StatusValidation.ERROR;
            }
        }
    }

    /* 
     * Vérifie que la date est bien inférieur à la date passée en paramètre (code : data-date-max) 
     * Attention la date passée en paramètre doit avoir le même pattern que la date à comparer
     */
    function checkMaxDateRange(selectedInput) {
        var dateMaxRange = selectedInput.attr("data-date-max");
        if (dateMaxRange != undefined) {
            var datePattern = _getDatePattern(selectedInput);
            var momentDateMax = moment(dateMaxRange, datePattern);
            if (moment.isMoment(momentDateMax)) {
                var momentDateReference = moment(selectedInput.val(), datePattern);
                if (momentDateReference.isAfter(momentDateMax)) {
                    var errorMessage = getErrorMessage(selectedInput, "data-date-max-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage);

                    return StatusValidation.ERROR;
                }
            } else {
                return StatusValidation.ERROR;
            }
        }
    }

    //#endregion

    //#region Atleastone
    /* Vérifie que parmis un ensemble de champs, au moins un est valide (selon les critères de validation qui lui sont attribué) (code : data-atleast-selector) */
    function checkAtLeastOne(selectedInput) {
        var selector = selectedInput.attr("data-atleast-selector");

        if (selector !== undefined) {
            var isValid = false;
            var $listeField = $("[data-atleast-selector='" + selector + "']");
            var currentMode = getSettingsCurrentMode(selectedInput); //getSettingsCurrentMode($listeField);
            setSettingsCurrentMode($listeField, modeValidation.VALIDATION_CLASSIQUE);
            $listeField.each(function () {
                if (CheckValidation($(this), false) === StatusValidation.SUCCESS) {
                    isValid = true;
                }

            });
            setSettingsCurrentMode($listeField, currentMode);
            if (isValid === false) {
                //On regarde si parmit le groupe, un champs spécifie un container
                if ($listeField.attr("data-message-container") !== undefined) {
                    selectedInput = $(_.take($("[data-atleast-selector='" + selector + "'][data-message-container]")));
                }
                var errorMessage = getErrorMessage(selectedInput, "data-atleast-message");
                //On désactive l'icone pour les validations groupés
                var currentSettings = $listeField.QuantaFormValidator("getSettings");
                disableIconSettings($listeField);

                WriteMessageForInvalidInput(selectedInput, errorMessage);
                //On remet les anciens settings après avoir écrit le message
                //$listeField.QuantaFormValidator("setSettings", currentSettings);
                return StatusValidation.ERROR;
            } else {
                //On enlève l'ancienne validation qu'il pouvait y avoir sur cette liste de champs
                RemoveOlderValidation($listeField);
                $listeField.each(function () {
                    SetUserInterface($(this), true);
                    fieldToSkip.push(this);
                });
                return StatusValidation.SUCCESS;
            }
        } else {
            return StatusValidation.VALIDATING;
        }
    }
    //#endregion

    //#region Champs identiques
    /* 
    * Vérifie que le champ est égal au champ passé en paramètre (code : data-equals)
    * Par défaut vérifie l'égalité, pour vérifier la différence utiliser data-equals-inverse="true"
   */
    function checkEqual(selectedInput) {
        var selector = selectedInput.attr("data-equals");

        if (selector !== undefined) {
            var referenceInput = $(selector);

            var inverse = selectedInput.attr("data-equals-inverse");

            if (inverse == "true") {
                if (selectedInput.val() == referenceInput.val()) {
                    var errorMessage = getErrorMessage(selectedInput, "data-equals-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage)
                    return StatusValidation.ERROR;
                } else {
                    return StatusValidation.VALIDATING;
                }
            } else {
                if (selectedInput.val() == referenceInput.val()) {
                    return StatusValidation.VALIDATING;
                } else {
                    var errorMessage = getErrorMessage(selectedInput, "data-equals-message");
                    WriteMessageForInvalidInput(selectedInput, errorMessage)
                    return StatusValidation.ERROR;
                }
            }
        } else {
            return StatusValidation.VALIDATING;
        }
    }
    //#endregion

    //#region Message d'erreurs
	function getErrorMessage(selectedInput, messageAttribute) {
        var errorMessage = selectedInput.attr(messageAttribute);
        if (errorMessage !== undefined && errorMessage != "") {
            return errorMessage;
        }

        switch (messageAttribute) {
            case "data-required-message":
                return i18n.QuantaFormValidator.required;
            case "data-string-length-message":
                //On génère un message en fonction du nombre de caractères min / max que l'on a paramétré
                var minLength = selectedInput.attr("data-string-length-min");
                var maxLength = selectedInput.attr("data-string-length-max");
                var eqLength = selectedInput.attr("data-string-length-equal");
                if (minLength !== undefined && maxLength !== undefined) {
                    return i18n.QuantaFormValidator.stringLengthBetween(minLength, maxLength);
                }
                if (minLength !== undefined && maxLength === undefined) {
                    return i18n.QuantaFormValidator.stringLengthMin(minLength);
                }
                if (minLength === undefined && maxLength !== undefined) {
                    return i18n.QuantaFormValidator.stringLengthMax(maxLength);
                }
                if (eqLength !== undefined) {
                    return i18n.QuantaFormValidator.stringLengthEqual(eqLength);
                }
                return "";
            case "data-isin-message":
                return i18n.QuantaFormValidator.isin;
            case "data-iban-message":
                return i18n.QuantaFormValidator.iban;
            case "data-bic-message":
				return i18n.QuantaFormValidator.bic;
            case "data-email-message":
                return i18n.QuantaFormValidator.email;
            case "data-url-message":
                return i18n.QuantaFormValidator.url;
            case "data-number-message":
				return i18n.QuantaFormValidator.number;
			case "data-number-integer-message":
				return i18n.QuantaFormValidator.numberInteger;
            case "data-number-min-message":
                var minValue = selectedInput.attr("data-number-min");
                return i18n.QuantaFormValidator.numberMin(minValue);
            case "data-number-max-message":
                var maxValue = selectedInput.attr("data-number-max");
                return i18n.QuantaFormValidator.numberMax(maxValue);
            case "data-text-message":
                return i18n.QuantaFormValidator.onlyString;
            case "data-phone-message":
                return i18n.QuantaFormValidator.phoneNumber;
            case "data-pattern-message":
                return i18n.QuantaFormValidator.pattern;
            case "data-autocomplete-message":
                return i18n.QuantaFormValidator.autocomplete;
            case "data-date-pattern-message":
                return i18n.QuantaFormValidator.dateFormat;
            case "data-date-min-message":
                return i18n.QuantaFormValidator.dateMin;
            case "data-date-max-message":
                return i18n.QuantaFormValidator.dateMax;
            case "data-atleast-one-checked-message":
                return i18n.QuantaFormValidator.atLeastOneChecked;
            case "data-atleast-message":
                return i18n.QuantaFormValidator.atLeastOne;
            case "data-equals-message":
                var referenceInput = selectedInput.attr("data-equals");
                //On prend l'attribut "title" du champ de référence
                var referenceInputName = $(referenceInput).attr("title");
                //Sinon on prend l'attribut "originalTitle"
                if (referenceInputName == "") {
                    referenceInputName = $(referenceInput).data("originalTitle");
                }
                //Sinon on prend son nom
                if (referenceInputName == "") {
                    referenceInputName = $(referenceInput).attr("name");
                }
                if (referenceInputName != "") {
                    if (selectedInput.attr("data-equals-inverse") == "true") {
                        return i18n.QuantaFormValidator.differentField(referenceInputName);
                    } else {
                        return i18n.QuantaFormValidator.equalField(referenceInputName);
                    }
                } else {
                    return i18n.QuantaFormValidator.unauthorized;
                }
            default:
                return i18n.QuantaFormValidator.default;
        }
    }
    //#endregion

    //#region Fonctions utilitaires
    /**
     * Génère un selecteur unique pour les "data-atleast-selector" automatiquement générés par le plugin
     */
    function _generateUniqueSelector() {
        var random = 0, isUnique = false, i = 0, guardrailIndex = 1000, prefix = "validation_";
        while (i < guardrailIndex && !isUnique) {
            random = Math.floor(Math.random() * guardrailIndex) + 1;
            if ($("[data-atleast-selector=" + prefix + random + "]").length == 0) {
                isUnique = true;
            }
            i++;
        }
        return prefix + random;
    }

    function _validateAttribute($elem, sAttribute, isFacultative) {
        if (isFacultative == null ? false : true)
            return $elem.attr(sAttribute) == null || ($elem.attr(sAttribute) != null && $elem.attr(sAttribute) !== "false");
        else
            return $elem.attr(sAttribute) != null && $elem.attr(sAttribute) !== "false";
    }
    //#endregion

    return methods;
});
